import { render, staticRenderFns } from "./SeminarAdd.vue?vue&type=template&id=966b3c40&scoped=true&"
import script from "./SeminarAdd.vue?vue&type=script&lang=js&"
export * from "./SeminarAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966b3c40",
  null
  
)

export default component.exports